import React from "react";

import { SaveType, postFileVersionDataExcel } from "../../../api/files";
import { DialogPhaseType } from "../../Dialog/helpers/hooks";
import { DragAndDropUploadData } from "../../DragAndDropFields";
import { useUploadSheetData } from "./useUploadSheetData";

/**
 * @description Excelアップ用の関数と状態を管理
 */
export const useUploadSheetDataExcel = (
  uploadedFileList: DragAndDropUploadData[],
  setUploadedFileList: React.Dispatch<
    React.SetStateAction<DragAndDropUploadData[]>
  >,
  uploadDialogPhaseType: DialogPhaseType,
  setUploadDialogPhaseType: (uploadDialogPhaseType: DialogPhaseType) => void,
  saveType: SaveType
) => {
  return useUploadSheetData(
    uploadedFileList,
    setUploadedFileList,
    uploadDialogPhaseType,
    setUploadDialogPhaseType,
    saveType,
    postFileVersionDataExcel
  );
};
